(() => {
  const init = (root = document) => {
    root.querySelectorAll?.('[data-gn-contact-modal]').forEach((dialog) => {
      if (dialog.dataset.gnReady === 'true') return;
      dialog.dataset.gnReady = 'true';

      const id = dialog.id;
      const openers = document.querySelectorAll(`[data-gn-contact-open="${id}"]`);
      const closers = dialog.querySelectorAll('[data-gn-contact-close]');
      const form = dialog.querySelector('.gn-contact-v2__contact-form');
      const upload = dialog.querySelector('[data-gn-upload]');
      const fileInput = upload?.querySelector('[data-gn-upload-input]');
      const uploadUrlInput = upload?.querySelector('[data-gn-upload-url]');
      const uploadStatus = upload?.querySelector('[data-gn-upload-status]');
      const submitButton = form?.querySelector('[data-gn-contact-submit]');
      const phoneInput = form?.querySelector('input[name="contact[phone]"]');
      const emailInput = form?.querySelector('input[name="contact[email]"]');
      const contactChoiceMessage = 'Completeaza numarul de WhatsApp sau adresa de e-mail.';

      const validateContactChoice = (report = false) => {
        if (!phoneInput || !emailInput) return true;
        const hasPhone = phoneInput.value.trim().length > 0;
        const hasEmail = emailInput.value.trim().length > 0;
        const valid = hasPhone || hasEmail;

        phoneInput.setCustomValidity(valid ? '' : contactChoiceMessage);
        emailInput.setCustomValidity('');

        if (!valid && report) phoneInput.reportValidity();
        return valid;
      };

      phoneInput?.addEventListener('input', () => validateContactChoice(false));
      emailInput?.addEventListener('input', () => validateContactChoice(false));

      const setUploadStatus = (message = '', type = '') => {
        if (!uploadStatus) return;
        uploadStatus.textContent = message;
        uploadStatus.classList.toggle('is-error', type === 'error');
        uploadStatus.classList.toggle('is-success', type === 'success');
      };

      fileInput?.addEventListener('change', () => {
        if (uploadUrlInput) uploadUrlInput.value = '';
        form?.removeAttribute('data-gn-upload-complete');
        const file = fileInput.files?.[0];
        if (!file) {
          setUploadStatus('');
          return;
        }
        const maxMb = Number(upload?.dataset.maxMb || 25);
        if (file.size > maxMb * 1024 * 1024) {
          fileInput.value = '';
          setUploadStatus(`Fisierul depaseste limita de ${maxMb} MB.`, 'error');
          return;
        }
        setUploadStatus(file.name);
      });

      form?.addEventListener('submit', async (event) => {
        if (!validateContactChoice(true)) {
          event.preventDefault();
          return;
        }

        const file = fileInput?.files?.[0];
        if (!file || form.dataset.gnUploadComplete === 'true') return;

        event.preventDefault();

        const cloudName = upload?.dataset.cloudName?.trim();
        const uploadPreset = upload?.dataset.uploadPreset?.trim();
        if (!cloudName || !uploadPreset) {
          setUploadStatus('Uploadul foto/video trebuie configurat in Customize.', 'error');
          return;
        }

        if (submitButton) submitButton.disabled = true;
        setUploadStatus('Se incarca fisierul...');

        try {
          const body = new FormData();
          body.append('file', file);
          body.append('upload_preset', uploadPreset);

          const response = await fetch(`https://api.cloudinary.com/v1_1/${encodeURIComponent(cloudName)}/auto/upload`, {
            method: 'POST',
            body
          });
          if (!response.ok) throw new Error('upload failed');
          const result = await response.json();
          if (!result.secure_url) throw new Error('missing url');

          uploadUrlInput.value = result.secure_url;
          form.dataset.gnUploadComplete = 'true';
          setUploadStatus('Fisier incarcat.', 'success');
          if (submitButton) submitButton.disabled = false;
          form.requestSubmit(submitButton || undefined);
        } catch (error) {
          if (submitButton) submitButton.disabled = false;
          setUploadStatus('Fisierul nu a putut fi incarcat. Incearca din nou.', 'error');
        }
      });

      const open = () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.documentElement.classList.add('gn-contact-modal-open');
      };

      const close = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        document.documentElement.classList.remove('gn-contact-modal-open');
      };

      openers.forEach((button) => button.addEventListener('click', open));
      closers.forEach((button) => button.addEventListener('click', close));

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });

      dialog.addEventListener('cancel', () => {
        document.documentElement.classList.remove('gn-contact-modal-open');
      });

      if (dialog.querySelector('[data-gn-contact-result]')) open();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
